import { Component, Input, Output,
         OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less']
})

export class DropdownComponent {
  @Input() links: Array<Array<string>>; // e.g. [['Link Title', 'linkRef], ...]
  @Input() rightAlign: boolean = false;
  @Output() onSelect: EventEmitter<string> = new EventEmitter<string>();
  public showMenu: boolean = false;

  constructor() {}

  public linkClicked(event, link): void {
    // Stop navigation, hide menu and execute the link handler
    event.preventDefault();
    this.showMenu = false;
    this.onSelect.emit(link);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/dropdown/dropdown.component.ts